import React from "react";
import Teams from "../../components/pages/teams/Teams";

export default function TeamsPage() {
  return <Teams />;
}
